import styled from "@emotion/styled";
import BaseButton from "src/atoms/Button/BaseButton";
import { hideScrollbar } from "src/scrollbar";

export const CarouselContainer = styled.div`
  position: relative;
  min-width: 0;

  &.full-width {
    width: 100vw;
    margin-inline-start: calc(
      var(--mobile-parent-padding-inline-start, 0px) * -1
    );
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    &.full-width-mobile {
      width: 100vw;
      margin-inline-start: calc(
        var(--mobile-parent-padding-inline-start, 0px) * -1
      );
    }
  }
`;

export const CarouselTrack = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: calc(
    (100% - (var(--mobile-items) - 1) * var(--gap)) / var(--mobile-items)
  );
  column-gap: var(--gap);
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  ${hideScrollbar}

  .carousel-slide {
    scroll-snap-align: start;
    scroll-snap-stop: always;
    min-width: 0;
  }

  &.full-width,
  &.full-width-mobile {
    padding-inline-start: var(--mobile-parent-padding-inline-start, 0px);
    padding-inline-end: var(--mobile-parent-padding-inline-end, 0px);
    scroll-padding-left: var(--mobile-parent-padding-inline-start, 0px);
    scroll-padding-right: var(--mobile-parent-padding-inline-end, 0px);
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-auto-columns: calc(
      (100% - (var(--tablet-items) - 1) * var(--gap)) / var(--tablet-items)
    );
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-auto-columns: calc(
      (100% - (var(--desktop-items) - 1) * var(--gap)) / var(--desktop-items)
    );
  }
`;

export const CarouselArrowButton = styled(BaseButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 32px;
  height: 32px;
  display: none;
  place-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.tone.white};
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.colors.tone.silver};
  cursor: pointer;
  z-index: 10;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    &:not([disabled]) {
      display: flex;
    }
  }

  &.hidden {
    display: none !important;
  }

  &:first-of-type {
    left: 0;
    transform: translate(-50%, -50%);
  }

  &:last-of-type {
    left: 100%;
    transform: translate(-50%, -50%) rotate(180deg);
  }

  svg {
    width: 16px;
    fill: ${({ theme }) => theme.colors.tone.anthraciteLight};
  }
`;
